import React, { Component } from "react";
import { Link } from "react-router-dom";

class SearchBookList extends Component {
	constructor(props) {
		super(props)


		this.state = { totalcount: 0, curpageidx: 0, booklist: [], loading: true };
		this.dofetchdata();


	}

	componentWillMount() {
		var self = this;
		window.addEventListener('scroll', function () {
			if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
				console.log("you're at the bottom of the page");
				if (self.state.loading === false) {
					self.dofetchdata();
				}
			}
		});
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll, true);
	}

	componentWillReceiveProps(props) {
		//alert(':  ' + JSON.stringify(props));
		//var val = JSON.stringify(props.url);
		//this.state = { bl: props.bl };
		//this.setState({ bl: props.bl });

		//alert(':: ' + JSON.stringify(this.state));

		//this.dorender();

	}

	dofetchdata() {

		this.state.loading = true;
		//alert(JSON.stringify(this.state));
		fetch(`/api/AB/BookList?pgidx=${this.state.curpageidx}&pgsize=50&&orderby=1&orderway=1`)
			.then(response => response.json())
			.then(data => {
				//this.setState({ forecasts: data, loading: false });
				//alert(JSON.stringify(data));
				//alert(data.totalcount);
				//this.state.totalcount = data.totalcount;
				//this.state.loading = true;
				//alert(this.state.totalcount);

				this.state.curpageidx++;
				this.state.loading = false;

				//alert(data.lstresult);

				this.state.booklist.push(...data.lstresult);

				//alert(this.state.booklist);

				this.setState({ totalcount: data.totalcount, curpageidx: this.state.curpageidx, booklist: this.state.booklist, loading: false });
				this.dorender();
			});

	}

	dorender() {
		//alert(JSON.stringify(this.state));
		let bookDummy = this.state.booklist;
		//alert(JSON.stringify(bookDummy));

		return (
				bookDummy.map((book, index) => {
					return (
						<React.Fragment>
							<li className="bookList-item">
								<Link to={`/book/${book.id}`}>
									<div className="bookList-thumbnail">
										<div className="thumbnail">
											<img
												className="thumbnail-image"
												src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.id}`}
												alt={book.subject}
											/>
										</div>
									</div>
									<div className="bookList-info">
										<h3 className="bookList-title">{book.subject}</h3>
										<h4 className="bookList-author">{book.authorName}</h4>
										<h4 className="bookList-publisher">{book.publisherName}</h4>
									</div>
								</Link>
							</li>
						</React.Fragment>
					);
				})
			
		);
	}

	render() {

		let contents = this.state.loading === true ? "loading..." : this.dorender();
		
		return (
			<React.Fragment>
				<ul className="bookList">
					{contents}
				</ul>
			</React.Fragment>
		);
	}
}

export default SearchBookList;
